module.exports = __webpack_public_path__ + "img/DigitalAdhesive1.27271ed9.jpg";